import React from "react";
import styled from "styled-components";
import { Button } from "./Button";

const ErrorContainer = styled.div`
  background-color: rgba(229, 62, 62, 0.1);
  border: 1px solid ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.error};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: 8px;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  width: 100%;
`;

const ErrorTitle = styled.p`
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.spacing.xs};
`;

const ErrorActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

interface ErrorMessageProps {
  message: string;
  title?: string;
  onDismiss?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  title = "Error",
  onDismiss,
}) => {
  return (
    <ErrorContainer>
      <ErrorTitle>{title}</ErrorTitle>
      <p>{message}</p>
      {onDismiss && (
        <ErrorActions>
          <Button onClick={onDismiss} variant="danger">
            Dismiss
          </Button>
        </ErrorActions>
      )}
    </ErrorContainer>
  );
};
